import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listAllUsers: [],
  listAllAdmins: [],
  listSpecialist: [],
  totalUsersAndroid: [],
  totalUsersIOS: [],
  totalUsersWeb: [],
  totalSpecialistNutricionist: [],
  totalSpecialistPhysiotherapy: [],
  totalSpecialistPsychologist: [],
  totalSpecialistCoach: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setListAllUsers: (state, action) => {
      state.listAllUsers = action.payload.listAllUsers ?? [];
      state.totalUsersAndroid = action.payload.listAllUsers.filter(
        (user) => user.origin === "android"
      );
      state.totalUsersIOS = action.payload.listAllUsers.filter(
        (user) => user.origin === "ios"
      );
      state.totalUsersWeb = action.payload.listAllUsers.filter(
        (user) => user.origin === "web"
      );
    },
    setListSpecialist: (state, action) => {
      state.listSpecialist = action.payload.listSpecialist ?? [];
      state.totalSpecialistNutricionist = action.payload.listSpecialist.filter(
        (user) => user?.role === "Nutricionist"
      );
      state.totalSpecialistPhysiotherapy = action.payload.listSpecialist.filter(
        (user) => user?.role === "Physiotherapy"
      );
      state.totalSpecialistPsychologist = action.payload.listSpecialist.filter(
        (user) => user?.role === "Psicology"
      );
      state.totalSpecialistCoach = action.payload.listSpecialist.filter(
        (user) => user?.role === "Coach"
      );
    },
    setLisAdmins: (state, action) => {
      state.listAllAdmins = action.payload.listAllAdmins ?? [];
    },
    clearListSpecialist: (state) => {
      state.listSpecialist = [];
    },
    clearListUsers: (state) => {
      state.listAllUsers = [];
    },
  },
});

export const {
  setListAllUsers,
  setListSpecialist,
  setLisAdmins,
  clearListSpecialist,
  clearListUsers,
} = usersSlice.actions;

export default usersSlice.reducer;
